import { useRef } from "react"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import useGetMediaDetail from "entity/media/useGetMediaDetail"
import usePostImgUpload from "entity/util/usePostImgUpload"
import usePutMedia from "entity/media/usePutMedia"

import CStyle from "shared/style/commonStyle"
import ITStyle from "shared/style/inputTableStyle"
import DefaultButton from "shared/ui/DefaultButton"

const MediaEdit = () => {
    const titleRef = useRef()
    const linkRef = useRef()
    const imgRef = useRef()

    const [mediaData] = useGetMediaDetail()
    const [imgState, uploadImgEvent, deleteImg] = usePostImgUpload(mediaData?.data?.img)
    const [putMedia] = usePutMedia(titleRef, imgState, linkRef)

    const btnList = [
        {
            "label": "저장",
            "clickEvent": () => putMedia(),
            "deactive": false
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <ITStyle.TableDiv>
                <ITStyle.TableElement>
                    <h2>제목<span>*</span></h2>
                    <input ref={titleRef} placeholder="40글자 이하" defaultValue={mediaData?.data?.title} />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>연결 링크<span>*</span></h2>
                    <input ref={linkRef} defaultValue={mediaData?.data?.url} />
                </ITStyle.TableElement>
            </ITStyle.TableDiv>

            <Style.AreaDiv>
                <h2>썸네일 첨부<span>*</span></h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 20mb 제한</p>
                    <p>16:9 비율의 이미지에 가장 최적화 되어 있습니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => imgRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={imgRef} onChange={uploadImgEvent} style={{ display: "none" }} />

                {imgState &&
                    <Style.ImgUploadDiv>
                        <Style.ImgElement>
                            <button onClick={deleteImg}>삭제</button>
                            <img src={imgState} onClick={() => window.open(imgState, "_blank")} />
                        </Style.ImgElement>
                    </Style.ImgUploadDiv>
                }

            </Style.AreaDiv>

        </Style.Wrapper>
    )
}

export default MediaEdit